import { render, staticRenderFns } from "./official_language.vue?vue&type=template&id=1a792593&"
import script from "./official_language.vue?vue&type=script&lang=js&"
export * from "./official_language.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports